import { Button, FormControl, FormLabel } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { padLeft } from 'BrokerTsLib/src/helpers/global'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useFindAddress } from '@/hooks'

import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { InputGroup } from '../../../components/InputGroup'
import { useNameof } from '../../../hooks/useNameof'
import { useGetAres } from '../../../hooks/useUser'
import { Cloud } from '../../../images/Cloud'
import { FormRow } from '../FormRow'

function ICOOptions({ personPrefix, disabled, hideIc }: { personPrefix: string, disabled?: boolean, hideIc?: boolean }) {
  const { isDisabled: isDisabledCtx } = useInsuranceParams()
  const isDisabled = isDisabledCtx || disabled

  const pnameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, watch, getFieldState, setValue, trigger } = useFormContext()

  const icPath = pnameof(x => x.idendificationNumber)
  const cnPath = pnameof(x => x.companyName)

  const ic = watch(icPath)
  const { mutateAsync: getAresAsync, isLoading } = useGetAres()

  const { mutateAsync: refetchAddress, isLoading: isLoadingAddress } = useFindAddress()

  const loadAres = () => getAresAsync(ic)
    .then((resp) => {
      const { adresaUlice, adresaCastObce, adresaObec, nazev, adresaPsc, adresaCislo } = resp ?? {}
      let ulice = adresaUlice
      if (!ulice) {
        ulice = !adresaCastObce ? adresaCastObce : adresaObec
      }
      setValue(pnameof(x => x.companyName), nazev)
      trigger(pnameof(x => x.companyName))

      return refetchAddress({ street: ulice, searchQuery: adresaCislo })
        .then(addresses => {
          if (addresses) {
            const pscFiltered = addresses?.filter(d => d.psc == adresaPsc) ?? []
            if (pscFiltered.length == 1) {
              const item = pscFiltered[0]
              setValue(pnameof(x => x.address.addressPoint), item.adresniMisto)
              setValue(pnameof(x => x.address.street), item.ulice)
              let cp = item.cisloDomovni
              if (item.cisloOrientacni) {
                cp = cp + '/' + item.cisloOrientacni
              }
              setValue(pnameof(x => x.address.streetNumber), cp)
              setValue(pnameof(x => x.address.postCode), item.psc)
              // let obec = item.obec
              // if (item.castObce && item.castObce != item.obec) {
              //     obec = obec + ' - ' + item.castObce
              // }
              setValue(pnameof(x => x.address.city), item.obec)

              trigger(pnameof(x => x.address.street))
              trigger(pnameof(x => x.address.streetNumber))
              trigger(pnameof(x => x.address.postCode))
              trigger(pnameof(x => x.address.city))
            }
          }
        })
    })

  const icError = getFieldState(icPath).error
  const cnError = getFieldState(cnPath).error

  return (
    <>
      <FormRow>
        {!hideIc &&
          <FormControl isInvalid={!!icError}>
            <FormLabel>
              IČO
            </FormLabel>

            <InputGroup
              isDisabled={isDisabled}
              id="bcn"
              placeholder="Např. 18628443"
              htmlSize={16}
              errors={icError}
              {...register(icPath, {
                onBlur: (e: any) => {
                  const val = e.target.value
                  setValue(icPath, val ? padLeft(val, 8, '0') : null) // doplneni zleva nulama
                }
              })}
              rightElement={
                <CustomTooltip label="Načíst údaje z ARES">
                  <Button
                    type="button"
                    variant="ghost"
                    isLoading={isLoading || isLoadingAddress}
                    isDisabled={isLoading || !ic || isDisabled}
                    onClick={loadAres}
                    padding={2}
                  >
                    <Cloud color="secondary.500" />
                  </Button>
                </CustomTooltip>
              }
            />
          </FormControl>}

        <FormControl isInvalid={!!cnError} isRequired>
          <FormLabel htmlFor="bcn">
            Název firmy
          </FormLabel>

          <InputGroup
            isDisabled={isDisabled}
            id="bcn"
            htmlSize={16}
            errors={cnError}
            {...register(cnPath)}
          />
        </FormControl>
      </FormRow>
    </>
  )
}

export default ICOOptions